package com.neurobs.react

import org.scalajs.dom
import org.scalajs.dom.HTMLElement
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useEffect
import slinky.core.facade.React
import slinky.web.html.{div, ref}

/**
 * React control that inserts a given HTML element into the
 * React managed div and never rerenders
 */
@react object HtmlAdapter {
	case class Props
	(
		element: HTMLElement,
		onAdd: Option[() => Unit] = None
	)

	val component = React.memo(
		FunctionalComponent[Props] { props =>
			val divRef = React.createRef[dom.html.Div]
				useEffect(() => {
					if (divRef.current != null) {
						divRef.current.appendChild(props.element)
						props.onAdd.foreach(_())
					}
				}, Seq())
			div(
				ref := divRef
			)
		},
		(_: Props, _: Props) => true
	)
}
